<template lang="pug">
    v-alert(type="error")
        | You are not currently logged into any queues. Please log into one or more queues to get started.
</template>

<script lang="ts">
    import Vue from 'vue';

    export default Vue.extend({
        data() {
            return {
            }
        },
        methods: {
        },
        computed: {
        },
        components: {
        },
        props: {
        },
    });
</script>

<style lang="scss" scoped>
</style>
